import './list.directive.ajscss';

import { isArray } from 'angular';

import templateUrl from './list.directive.ajs.html';

export let ListDirective = () => ({
  restrict: 'E',
  require: 'ngModel',
  transclude: false,
  scope: {
    ngModel: '<',
  },
  link: (scope, elem) => {
    scope.ngModel = isArray(scope.ngModel) ? scope.ngModel : [];

    // fix to prevent memory leak
    scope.$on('$destroy', () => {
      // remove listener
    });
    elem.on('$destroy', () => {
      scope.$destroy();
    });
  },
  templateUrl,
});

export default 'cngList';
